import { render, staticRenderFns } from "./BoxEditor.vue?vue&type=template&id=5d58614c&scoped=true&"
import script from "./BoxEditor.vue?vue&type=script&lang=js&"
export * from "./BoxEditor.vue?vue&type=script&lang=js&"
import style1 from "./BoxEditor.vue?vue&type=style&index=1&id=5d58614c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58614c",
  null
  
)

export default component.exports